import React from 'react';
import Wrapper from '@common/pages/Wrapper';
import TabsComponent from '@common/TabsComponent';
import DeploymentFooter from '@/components/DeploymentFooter';
import ScanRosterTool from '@/components/pages/tools/ScanRosterTool';
import BulkUserUploadTool from '@/components/pages/tools/bulk_user_upload/BulkUserUploadTool';
import DiagnosisCodesUpdate from '@/components/pages/tools/DiagnosisCodesUpdate';
import SendSmsTool from "@/components/pages/tools/SendSmsTool";
import UserPermissionsUpdate from "@/components/pages/tools/UserPermissionsUpdate";

const ToolsPage = () => {
  const tabs = [
    {
      value: 0,
      label: 'Scan Roster',
      route: '/tools/scan_roster',
      content: <ScanRosterTool />
    },
    {
      value: 1,
      label: 'Bulk User Upload',
      route: '/tools/bulk_user_upload',
      content: <BulkUserUploadTool />
    },
    {
      value: 2,
      label: 'Diagnosis Codes Update',
      route: '/tools/diagnosis_codes_update',
      content: <DiagnosisCodesUpdate />
    },
    {
      value: 3,
      label: 'Send SMS',
      route: '/tools/sms',
      content: <SendSmsTool />
    },
    {
      value: 4,
      label: 'User Permissions Revamp',
      route: '/tools/user_permissions_revamp',
      content: <UserPermissionsUpdate />
    },
  ];

  return (
    <Wrapper>
      <TabsComponent tabs={tabs} />
      <DeploymentFooter />
    </Wrapper>
  );
};

export default ToolsPage;
